<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto" [dir]="isRTL ? 'rtl' : 'ltr'">

  <div class="position-absolute w-100 d-flex zx-z-index-1" [class.justify-content-end]="isRTL">
    <button type="button" mat-icon-button aria-label="Close" (click)="closeDialog()"
      class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode"
      [disabled]="isSending">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100 position-relative">

    <h4 *ngIf="!isSent" class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
      {{ 'wall.contact.title' | translate:{ name: titleName } }}
    </h4>

    <ng-container *ngIf="!isSent && !isSending">
      <textarea
        class="form-control wall-contact-textarea"
        rows="6"
        [maxlength]="maxLength"
        [placeholder]="'wall.contact.placeholder' | translate"
        [(ngModel)]="message"
        name="wallContactMessage"></textarea>

      <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-2 w-100 pt-2">
        <button type="button" (click)="onSend()" [disabled]="!canSend()" mat-raised-button
          class="rounded-pill flex-grow-1 fw-bold text-white wall-contact-btn-send">
          {{ 'wall.contact.send' | translate }}
        </button>
        <button type="button" (click)="closeDialog()" mat-button
          class="rounded-pill flex-grow-1 fw-bold wall-contact-btn-cancel">
          {{ 'su-management.branches_cancel' | translate }}
        </button>
      </div>
    </ng-container>

    <div *ngIf="isSending" class="wall-contact-sending d-flex flex-grow-1 justify-content-center align-items-center w-100">
      <mat-spinner diameter="36"></mat-spinner>
    </div>

    <div *ngIf="isSent" class="d-flex flex-column align-items-center gap-2 w-100 pt-2 wall-contact-success">
      <img src="assets/images/success-icon.svg" class="svg wall-contact-success-icon" alt="">
      <b class="text-center" [class.text-white]="isDarkMode">{{ 'wall.contact.success' | translate }}</b>
      <p class="text-center mb-0 wall-contact-success-hint" [class.text-white]="isDarkMode">
        {{ 'wall.contact.success-hint' | translate }}
      </p>
      <button type="button" (click)="closeDialog()" mat-raised-button
        class="rounded-pill fw-bold text-white wall-contact-btn-send mt-2">
        {{ 'close-branch.btn' | translate }}
      </button>
    </div>

  </div>
</div>
